import React from 'react';
import { Github, Twitter, Linkedin, Facebook, Mail } from 'lucide-react';  // Importing Lucide icons
import '../assets/styles/Footer.css';

const Footer = () => {
  return (
    <>
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <p className="footer-text">Powered by Mohammad Abreeq</p>
        </div>

        <div className="footer-center">
          <h4 className="footer-title">Quick Links</h4>
          <div className="footer-links">
            <a href="/privacy-policy" className="footer-link">Privacy Policy</a>
            <a href="/terms-of-service" className="footer-link">Terms of Service</a>
            <a href="/about" className="footer-link">About Us</a>
            <a href="/contact" className="footer-link">Contact</a>
          </div>
        </div>

        <div className="footer-right">
          <h4 className="footer-title">Stay Connected</h4>
          <div className="social-icons">
            <a href="#" className="icon-link">
              <Facebook className="icon" />
            </a>
            <a href="#" className="icon-link">
              <Twitter className="icon" />
            </a>
            <a href="#" className="icon-link">
              <Linkedin className="icon" />
            </a>
            <a href="#" className="icon-link">
              <Github className="icon" />
            </a>
            <a href="mailto:contact@webdevsolutions.com" className="icon-link">
              <Mail className="icon" />
            </a>
          </div>
        </div>
      </div>
    </footer>
    </>
  );
};

export default Footer;
